module.exports = __webpack_public_path__ + "static/demo-431c6f0e56f42d48e2379767208ce30b.jpg";